module.exports = __webpack_public_path__ + "static/media/pulsea.31dbc538.png";